import { defineComponent, PropType, ref, computed } from 'vue';
import useAsync from '@/hooks/useAsync';

enum DisplayType {
  None,
  AllUp,
  SomeDown,
}

export default defineComponent({
  // props: {
  // },
  setup(props, { emit }) {
    const statusResult = useAsync(() => fetch('/api/status').then(res => res.json()));
    const statusDisplay = computed(() => {
      if (!statusResult.data?.value?.heartbeatList) return DisplayType.None;
      const heartbeatList = Object
        .values(statusResult.data.value.heartbeatList)
        .filter(Array.isArray)
        .map(it => it[it.length - 1]);
      const allUp = heartbeatList.every(it => it.status === 1);
      return allUp ? DisplayType.AllUp : DisplayType.SomeDown;
    });

    return () => {
      switch (statusDisplay.value) {
        case DisplayType.AllUp:
          return <div class="flex gap-2 items-center justify-center">
            <span class="i-carbon-checkmark-filled c-green-6 text-5" />
            所有服务运行正常
          </div>;
        case DisplayType.SomeDown:
          return <div class="flex gap-2 items-center justify-center">
            <span class="i-carbon-warning-filled c-orange-6 text-5" />
            部分服务出现故障
          </div>;
      }
    };
  },
});
